(function () {
  function checkScroll() {
    if (window.scrollY > 0) {
      document.documentElement.classList.add('is-scrolled');
    } else {
      document.documentElement.classList.remove('is-scrolled');
    }
  }

  function initScroll() {
    checkScroll();
    window.addEventListener('DOMContentLoaded', checkScroll);
    window.addEventListener('scroll', checkScroll, {
      passive: true,
    });
  }

  initScroll();
})();
